import CryptoJS from "crypto-js";

export const AESEncryptJSON = (message) => {
  if (message) {
    const messageJSON = JSON.stringify(message);
    const encrypted = CryptoJS.AES.encrypt(messageJSON, process.env.NODE_ENV);
    const encryptedMessage = encrypted.toString();
    return encryptedMessage;
  }
  return message;
};

export const AESEncryptString = (message) => {
  if (message) {
    const encrypted = CryptoJS.AES.encrypt(message, process.env.NODE_ENV);
    const encryptedMessage = encrypted.toString();
    return encryptedMessage;
  }
  return message;
};

export const AESEncryptURL = (message) => {
  if (message) {
    const encrypted = CryptoJS.AES.encrypt(message, process.env.NODE_ENV);
    const encryptedMessage = encrypted
      .toString()
      .replaceAll("+", "xMl3Jk")
      .replaceAll("/", "Por21Ld")
      .replaceAll("=", "Ml32");
    return encryptedMessage;
  }
  return message;
};
